// extracted by mini-css-extract-plugin
export default {"brandName":"Navbar_brandName__PJlkt","navbar":"Navbar_navbar__n7ygh","navbarContainer":"Navbar_navbarContainer__nQYuK","navButton":"Navbar_navButton__A9lZc"};